<h2 mat-dialog-title class="text-lg font-bold mb-1">Agregar detalle</h2>
<mat-dialog-content class="modal-content">
  <form #updateForm="ngForm" class="grid grid-cols-2 gap-4 items-center">
    <mat-form-field class="w-full col-span-2">
      <mat-label>Material</mat-label>
      <mat-select
        [formControl]="materialControl"
        name="materialId"
        placeholder="Seleccione material"
        [multiple]="false"
        (selectionChange)="onMaterialChange($event.value)"
        [compareWith]="compareById"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="materialFilterControl"
            [noEntriesFoundLabel]="'No se encontraron resultados'"
            [placeholderLabel]="'Buscar material...'"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let material of filteredMaterialList | async"
          [value]="material"
          [disabled]="isDisabledMaterial(material)"
        >
          <b>{{ material?.externalKeys?.code }}</b> -
          {{ material.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="materialControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
        <!-- Agregar solo para devolucion y cambio -->
      <mat-form-field  *ngIf="isTypeValid" class="w-full">
        <mat-label>Motivo de Cambio</mat-label>
        <mat-select [formControl]="returnTypeControl" name="returnTypeId" placeholder="Seleccione motivo de cambio"
          [multiple]="false" [compareWith]="compareById">
          <mat-option>
            <ngx-mat-select-search [formControl]="returnTypeFilterControl"
              [noEntriesFoundLabel]="'No se encontraron resultados'"
              [placeholderLabel]="'Buscar motivo de cambio...'"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let returnType of filteredReturnTypeList | async" [value]="returnType">
            <b>{{ returnType?.code }}</b> -
            {{ returnType.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="returnTypeControl.hasError('required')">
          Este campo es obligatorio.
        </mat-error>
      </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Almacén</mat-label>
      <mat-select
        [formControl]="warehouseControl"
        name="warehouseId"
        [required]="warehouseRequired"
        [disabled]="warehouseDisabled"
        (selectionChange)="onWarehouseChange()"
      >
        <mat-option
          *ngFor="let warehouse of data.order['warehousesToUpdate'] || []"
          [value]="warehouse._id"
          class="text-content"
        >
        {{warehouse.externalKeys ? warehouse.externalKeys?.code + ' - ' : (warehouse.code ? warehouse.code + ' - ' : '')}}{{ warehouse.name }}
      </mat-option>
      </mat-select>
      <mat-error *ngIf="warehouseControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
    
    <mat-form-field class="w-full">
      <mat-label>Unidad de medida</mat-label>
      <mat-select
        [formControl]="soldUnitOfMeasureControl"
        name="soldUnitOfMeasureId"
        [required]="soldUnitOfMeasureRequired"
        [disabled]="soldUnitOfMeasureDisabled"
        (selectionChange)="onUnitOfMeasureChange()"
      >
        <mat-option
          *ngFor="let materialUnitOfMeasure of soldUnitOfMeasureList"
          [value]="materialUnitOfMeasure.unitOfMeasure._id"
          class="text-content"
        >
          {{ materialUnitOfMeasure.unitOfMeasure.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="soldUnitOfMeasureControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Cantidad</mat-label>
      <input
        matInput
        type="number"
        [formControl]="soldQuantityControl"
        name="soldQuantity"
        placeholder="Cantidad"
        (change)="onQuantityChange()" 
        (keyup)="onQuantityChange()"
        required
      />
       <span matSuffix class="text-gray-500 ml-2">{{materialControl?.value?.baseUnitOfMeasure?.code}}</span>
      <mat-error *ngIf="soldQuantityControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
     <mat-form-field *ngIf="isTypeValid" class="w-full">
    <mat-label>Cantidad paralela</mat-label>
    <input
      matInput
      type="number"
      [value]="parallelQuantity"
      readonly
    />
    <span matSuffix class="text-gray-500 ml-2">{{this.ump}}</span>
  </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Precio</mat-label>
      <input
        matInput
        type="number"
        [formControl]="unitPriceControl"
        name="unitPrice"
        placeholder="Precio"
        [readonly]="data.order.class.canUpdatePrices == true ? false : true"
      />
      <mat-error *ngIf="unitPriceControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>

    @if(this.data.useRejectionMotive){
    <mat-form-field class="w-full">
      <mat-label>Motivo de rechazo</mat-label>
      <mat-select [formControl]="reasonRejectionControl" name="reasonRejectionId" required>
        <mat-option>
          <ngx-mat-select-search [(ngModel)]="searchReasonRejection" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="changueOptionRejection($event)" placeholderLabel="Buscar..."
            noEntriesFoundLabel="No se encontraron resultados">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let reasonRejection of filteredReasonRejectionList" [value]="reasonRejection">
          {{ reasonRejection.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="reasonRejectionControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
    }
   
    <div *ngIf="showCurrentStockForMaterials">
      <span style="margin-top: -0.7em">
        <b
          [style.color]="
            stockToValidate >= soldQuantityControl.value ? 'green' : 'inherit'
          "
        >
          Disponible:
        </b>
        {{ stockToValidate }}
      </span>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="
      !updateForm.valid ||
      !materialControl.valid ||
      !soldUnitOfMeasureControl.valid ||
      !warehouseControl.valid ||
      !soldQuantityControl.valid ||
      !unitPriceControl.value ||
      unitPriceControl.value === 0 ||
      !reasonRejectionControl.valid && this.data.useRejectionMotive
    "
    class="justify-end"
  >
    Agregar
  </button>
</mat-dialog-actions>
